module.exports = __webpack_public_path__ + "static/media/box-fragile.78be33ec.svg";